import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'renewals-form',
  templateUrl: './renewals-form.component.html',
  styleUrls: ['./renewals-form.component.css']
})
export class RenewalsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/Renewals/renewals-form/renewals-form.component.ts